import { useState } from 'react'

const SEEN_KEY = 'moodboard_onboarding_tutorial_seen'

// Whether the first-run tutorial card on the onboarding canvas is still open. Lives
// with the page (not inside the card) because the Finalize nudge waits for it to be
// dismissed. Remembered per browser; storage failures just mean it shows again.
export function useOnboardingTutorial() {
  const [open, setOpen] = useState(() => {
    try {
      return localStorage.getItem(SEEN_KEY) !== '1'
    } catch {
      return true
    }
  })

  const dismiss = () => {
    try {
      localStorage.setItem(SEEN_KEY, '1')
    } catch {
      // ignore — worst case the card shows again next visit
    }
    setOpen(false)
  }

  return { open, dismiss }
}
